import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, FormInput, FormFeedback, Button } from "shards-react";
import { Formik } from 'formik';
import axios from 'axios';

function handleFetchError(setErrorMessage, setSubmitting) {
    axios.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response.status === 401) {
            const exitCode = error.response.headers['x-exit'];
            if (exitCode == 'wrongPassword') setErrorMessage('Password salah');
            else if (exitCode == 'wrongUsername') setErrorMessage('Username salah');
            else if (exitCode == 'wrongServer') setErrorMessage('Server SSO sedang bermasalah');
            setSubmitting(false);
            return "";
        }
        return error;
    });
}

export default function LoginSsoForm({ userType, activeColor }) {
    const [errorMessage, setErrorMessage] = useState('');
    const handleSubmit = (values, actions) => {
        handleFetchError(setErrorMessage, actions.setSubmitting);
        axios.post('/entrance/login-sso', {
            username: values.username,
            password: values.password
        }).then(res => {
            console.log(res.data)
            if (res.status == 200) window.location = res.data;
            actions.setSubmitting(false);
            return;
        }).catch(err => {
            console.log(err);
        })
    }
    const userLabel = userType == 'student' ? 'Mahasiswa' : 'Dosen';
    return (
        <div>
            <h4>Login SSO</h4>
            <Formik
                initialValues={{ username: '', password: '' }}
                onSubmit={handleSubmit}
            >
                {props => (
                    <Form onSubmit={props.handleSubmit}>
                        <FormGroup>
                            <label htmlFor="username">Username</label>
                            <FormInput
                                type="text"
                                onChange={props.handleChange}
                                onBlur={props.handleBlur}
                                value={props.values.username}
                                name="username"
                            />
                        </FormGroup>
                        <FormGroup>
                            <label htmlFor="password">Password</label>
                            <FormInput
                                type="password"
                                onChange={props.handleChange}
                                onBlur={props.handleBlur}
                                value={props.values.password}
                                name="password"
                            />
                        </FormGroup>
                        <p>{errorMessage}</p>
                        <button type="submit" disabled={props.isSubmitting} style={{
                            width: '100%', padding: '0.6rem', borderRadius: 6, border: 'none',
                            backgroundColor: props.isSubmitting ? '#9ca3af' : (activeColor || '#16a34a'),
                            color: '#fff', fontWeight: 600, fontSize: '1rem',
                            cursor: props.isSubmitting ? 'not-allowed' : 'pointer',
                        }}>Login</button>
                    </Form>
                )}
            </Formik>
            {/* <p style={{textAlign: 'center'}}>Login sebagai admin <a href="/internal-login">disini</a></p> */}
        </div>
    );
}

LoginSsoForm.propTypes = {
    userType: PropTypes.oneOf(['STUDENT', 'LECTURER'])
}